module.exports = __webpack_public_path__ + "img/call1.5864d577.svg";